import { render, staticRenderFns } from "./TierSelect.vue?vue&type=template&id=55874e3d&"
import script from "./TierSelect.vue?vue&type=script&lang=ts&"
export * from "./TierSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55874e3d')) {
      api.createRecord('55874e3d', component.options)
    } else {
      api.reload('55874e3d', component.options)
    }
    module.hot.accept("./TierSelect.vue?vue&type=template&id=55874e3d&", function () {
      api.rerender('55874e3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/TierSelect.vue"
export default component.exports